import { Button, Card, Col, DatePicker, Form, Input, Row, Select, Space, theme } from 'antd';
import { useEffect, useState } from 'react';
import { computeButtonColLayout, filterFormGridLayout, filterFormItemLayout, filterFormItemStyle } from '@utils/property';
import dayjs from 'dayjs';
import './SignUpListFilterPanel.less';

const VISIBLE_FIELD_COUNT = 4;
const TOTAL_FIELD_COUNT = 8;

export default function SignUpListFilterPanel({ filter, identityOptions, channelList, signOptions, onFinish, onReset }) {
    const { token } = theme.useToken();
    const [form] = Form.useForm();
    const [expanded, setExpanded] = useState(false);
    const buttonColLayout = computeButtonColLayout(expanded ? TOTAL_FIELD_COUNT : VISIBLE_FIELD_COUNT);

    useEffect(() => {
        const time = filter.time ?? (filter.startTime && filter.endTime ? [dayjs(filter.startTime), dayjs(filter.endTime)] : undefined);
        form.setFieldsValue({
            memUserName: filter.memUserName,
            phone: filter.phone,
            identityId: filter.identityId,
            unitName: filter.unitName,
            isCheckedIn: filter.isCheckedIn,
            channelId: filter.channelId,
            time,
            regNo: filter.regNo,
        });
        // 如果有展开字段的值，则自动展开
        if (filter.channelId !== undefined || filter.time !== undefined || filter.regNo !== undefined || filter.isCheckedIn !== undefined) {
            setExpanded(true);
        }
    }, [filter, form]);

    const handleReset = () => {
        form.resetFields();
        setExpanded(false);
        onReset();
    };

    return (
        <Card
            size="small"
            className="signup-list-filter-panel"
            style={{
                marginBottom: token.marginLG,
                border: `1px solid ${token.colorBorderSecondary}`,
                background: token.colorFillAlter,
            }}
        >
            <Form {...filterFormItemLayout} form={form} onFinish={onFinish} autoComplete="off" requiredMark={false}>
                <Row gutter={[16, 16]}>
                    <Col {...filterFormGridLayout}>
                        <Form.Item label="姓名" name="memUserName" style={filterFormItemStyle}>
                            <Input allowClear placeholder="请输入姓名" />
                        </Form.Item>
                    </Col>

                    <Col {...filterFormGridLayout}>
                        <Form.Item label="手机号" name="phone" style={filterFormItemStyle}>
                            <Input allowClear placeholder="请输入手机号" />
                        </Form.Item>
                    </Col>

                    <Col {...filterFormGridLayout}>
                        <Form.Item label="身份" name="identityId" style={filterFormItemStyle}>
                            <Select placeholder="请选择身份" options={identityOptions} fieldNames={{ label: 'name', value: 'id' }} allowClear />
                        </Form.Item>
                    </Col>

                    <Col {...filterFormGridLayout}>
                        <Form.Item label="单位" name="unitName" style={filterFormItemStyle}>
                            <Input allowClear placeholder="请输入单位" />
                        </Form.Item>
                    </Col>

                    {expanded && (
                        <>
                            <Col {...filterFormGridLayout}>
                                <Form.Item label="是否签到" name="isCheckedIn" style={filterFormItemStyle}>
                                    <Select placeholder="请选择是否签到" options={signOptions} fieldNames={{ label: 'name', value: 'id' }} allowClear />
                                </Form.Item>
                            </Col>

                            <Col {...filterFormGridLayout}>
                                <Form.Item label="报名渠道" name="channelId" style={filterFormItemStyle}>
                                    <Select
                                        placeholder="请选择报名渠道"
                                        options={channelList}
                                        fieldNames={{ label: 'title', value: 'id' }}
                                        allowClear
                                        showSearch={{
                                            filterOption: (input, option) => (option?.title ?? '').toLowerCase().includes(input.toLowerCase()),
                                        }}
                                    />
                                </Form.Item>
                            </Col>

                            <Col {...filterFormGridLayout}>
                                <Form.Item label="报名时间" name="time" style={filterFormItemStyle}>
                                    <DatePicker.RangePicker
                                        showTime={{
                                            hideDisabledOptions: true,
                                            defaultValue: [dayjs('00:00', 'HH:mm'), dayjs('11:59', 'HH:mm')],
                                        }}
                                        format="YYYY-MM-DD HH:mm"
                                        allowClear
                                    />
                                </Form.Item>
                            </Col>

                            <Col {...filterFormGridLayout}>
                                <Form.Item label="报名编号" name="regNo" style={filterFormItemStyle}>
                                    <Input allowClear placeholder="请输入报名编号" />
                                </Form.Item>
                            </Col>
                        </>
                    )}

                    <Col {...buttonColLayout}>
                        <Form.Item label={<span>&nbsp;</span>} colon={false} style={filterFormItemStyle}>
                            <Space size="small">
                                <Button type="primary" htmlType="submit" icon={<i className="bi bi-search" aria-hidden="true" />}>
                                    检索
                                </Button>
                                <Button type="default" onClick={handleReset}>
                                    重置
                                </Button>
                                <Button type="link" size="small" aria-expanded={expanded} onClick={() => setExpanded(prev => !prev)} style={{ fontSize: 12, color: token.colorTextSecondary }}>
                                    {expanded ? (
                                        <>
                                            收起 <span className="bi bi-chevron-up" aria-hidden="true" />
                                        </>
                                    ) : (
                                        <>
                                            展开 <span className="bi bi-chevron-down" aria-hidden="true" />
                                        </>
                                    )}
                                </Button>
                            </Space>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Card>
    );
}
